<template>
  <div>
    <modal-cadu close :width="770.52" v-model="show">
      <div slot="all" class="py-10 px-10">
        <div slot="header">
          <div class="font-primaria primary1--text headline font-weight-bold pb-4">
            ADICIONAR APELIDO
          </div>
        </div>
        <div slot="body" class="border-body" :class="$vuetify.breakpoint.xs ? 'pb-4' : ''">
            <v-row>
                <v-col cols="6">
                    <input-cadu
                        disabled
                        title="Unimed"
                        v-model="unimedProp.nome"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <validation-provider name="apelido" ref="apelido" mode="eager" rules="required" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            title="Apelido"
                            v-model="apelido"
                        />
                    </validation-provider>
                </v-col>
            </v-row>
        </div>
        <div slot="footer">
          <div v-if="!$vuetify.breakpoint.xs">
              <v-row
                align="center"
                justify="start"
                class="mt-4"
              >
                <v-row
                  align="center"
                  justify="start"
                  no-gutters
                  class="mr-2"
                >
                  <v-col cols="auto">
                    <button-cadu
                      text="VOLTAR"
                      outline
                      @click="$emit('input', false)"
                    />
                  </v-col>
                </v-row>
                <v-row
                  align="end"
                  justify="end"
                  class="mr-2"
                >
                  <v-col cols="12" sm="auto">
                      <button-cadu
                        text="SALVAR E ADICIONAR OUTRO"
                        @click="saveCloseTag(true)"
                        block
                        :backColor="$vuetify.theme.themes.light.primary2"
                        class="px-4"
                      />
                  </v-col>
                  <v-col cols="12" sm="auto">
                      <button-cadu
                        text="SALVAR"
                        @click="saveCloseTag"
                        :backColor="$vuetify.theme.themes.light.primary1"
                      />
                  </v-col>
                </v-row>
              </v-row>
          </div>
          <div v-else>
              <v-row
                align="center"
                justify="center"
                class="linha pt-4"
              >
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-col cols="12">
                      <button-cadu
                        text="SALVAR"
                        block
                        @click="saveCloseTag"
                        :backColor="$vuetify.theme.themes.light.primary2"
                      />
                  </v-col>
                  <v-col cols="12">
                      <button-cadu
                        text="SALVAR E ADICIONAR OUTRO"
                        @click="saveCloseTag(true)"
                        block
                        :backColor="$vuetify.theme.themes.light.primary1"
                      />
                  </v-col>
                  <v-col cols="12">
                    <button-cadu
                      block
                      text="VOLTAR"
                      outline
                      @click="$emit('input', false)"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </div>
        </div>
      </div>
    </modal-cadu>
    <overlay-loading v-model="loadingOverlay"/>
    <error-modal
      v-model="error"
      :errObj="errObj"
    />
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import Unimed from '@/services/Unimed'

export default {
  components: {
    ValidationProvider
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    unimedProp: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      apelido: '',
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      loadingOverlay: false,
      show: false,
      tokenBearer: localStorage.getItem('tokenBearer')
    }
  },
  methods: {
    async saveTag (bool) {
      let unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)

      try {
        await unimed.putTags(this.unimedProp.id, this.apelido)
        this.$emit(bool ? 'inputAnother' : 'inputNormal')
        this.apelido = ''
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async saveCloseTag (bool = false) {
      let res = await this.$refs.apelido.validate()
      if (res.valid) {
        this.loadingOverlay = true
        await this.saveTag(bool)
        this.loadingOverlay = false
      }
    }
  },
  watch: {
    show () {
      this.apelido = this.show ? this.apelido : ''
      this.$emit('input', this.show)
    },
    value () {
      this.show = this.value
    }
  }
}
</script>
